import { z } from "zod";
import { CATEGORY, COMMENTS, NAME, PRIORITY, TERM } from "../consts";

export const schema = z.object({
  [NAME]: z.string().min(1, "This field is required"),
  [CATEGORY]: z.string().min(1, "This field is required"),
  [PRIORITY]: z.string().min(1, "This field is required"),
  [TERM]: z.string().min(1, "This field is required"),
  [COMMENTS]: z.string().min(1, "This field is required"),
});

export type formValues = z.infer<typeof schema>;
